var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakedPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#paint0_radial_2365_5810)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0141 10.1113C24.5507 10.5747 23.7556 10.7156 23.2922 10.2522L21.279 8.23905C20.7698 7.7298 19.9441 7.7298 19.4349 8.23905L17.4217 10.2523C16.9583 10.7156 16.1631 10.5747 15.6997 10.1113C14.1565 8.56803 11.6544 8.56804 10.1111 10.1113C8.56785 11.6545 8.56785 14.1567 10.1111 15.6999C10.5745 16.1633 10.7155 16.9584 10.2521 17.4218L8.23887 19.435C7.72962 19.9443 7.72962 20.7699 8.23887 21.2792L10.2521 23.2924C10.7155 23.7558 11.5106 23.6148 11.974 23.1514C13.5172 21.6082 16.0194 21.6082 17.5626 23.1514C19.1059 24.6947 19.1059 27.1968 17.5626 28.7401C17.0992 29.2035 16.9583 29.9986 17.4217 30.462L19.4349 32.4752C19.9441 32.9844 20.7698 32.9844 21.279 32.4752L23.2922 30.462C23.7556 29.9986 24.5507 30.1395 25.0141 30.6029C26.5574 32.1462 29.0595 32.1462 30.6028 30.6029C32.146 29.0597 32.146 26.5576 30.6028 25.0143C30.1394 24.5509 29.9984 23.7558 30.4618 23.2924L32.475 21.2792C32.9842 20.7699 32.9842 19.9443 32.475 19.435L30.4618 17.4218C29.9984 16.9584 30.1394 16.1633 30.6028 15.6999C32.146 14.1567 32.146 11.6546 30.6028 10.1113C29.0595 8.56803 26.5574 8.56804 25.0141 10.1113Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2365_5810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(45) scale(28.2843)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0849394,
    stopColor: "#7075E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181931"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakedPuzzle);
export default __webpack_public_path__ + "static/media/staked-puzzle.998e3eee36faac5cdc473f04e7bf41aa.svg";
export { ForwardRef as ReactComponent };